import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { authorization } from 'Module/Auth/Auth'
import { INVENTORY_FLYER_ITEM_TYPE, ROLE_ADMIN } from 'shared/constants'
import {
  deleteFlyerCode,
  processInventoryMovement,
} from 'Reducers/Inventory/actions'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'

import Button from 'Components/Form/Button'
import Form from 'Components/Form'

const InventoryAddModal = props => {
  const { handleCancel, handleConfirm, item, cityId } = props
  const dispatch = useDispatch()

  const { role } = authorization.getUser()
  const isFlyerPack = item.typeId == INVENTORY_FLYER_ITEM_TYPE

  if (isFlyerPack && role !== ROLE_ADMIN) {
    return (
      <Modal show>
        <ModalHeader hideCancel onHide={handleCancel}>
          <ModalTitle> Not Authorized </ModalTitle>
        </ModalHeader>
        <ModalBody>
          You are not authorized to delete flyer packs. Please, contact an ops
          manager or the administrator
        </ModalBody>
        <ModalFooter>
          <Button className="submit-button" value="OK" onClick={handleCancel} />
        </ModalFooter>
      </Modal>
    )
  }

  const message = isFlyerPack
    ? `Delete flyer pack "${item.description}"? This action cannot be undone.`
    : `Delete item "${item.description}"?`

  const onConfirm = useCallback(
    e => {
      if (isFlyerPack) {
        dispatch(deleteFlyerCode(item.id))
        setTimeout(handleConfirm, 3000)
      } else {
        dispatch(
          processInventoryMovement({
            cityId: Number(cityId),
            // Should be a negative amount for the quantity as we are deleting
            quantity: -item.quantity,
            inventoryId: Number(item.id),
            ambassadorId: null,
            comments: 'Deleted on inventory page.',
            movement: 0,
            dateTime: new Date().toISOString(),
          }),
        )
        setTimeout(handleConfirm, 3000)
      }
    },
    [item, cityId],
  )

  return (
    <Form>
      <Modal show>
        <ModalHeader closeButton onHide={handleCancel}>
          <ModalTitle>Warning</ModalTitle>
        </ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter>
          <Button
            className="submit-button"
            value="Cancel"
            onClick={handleCancel}
          />
          <Button value="Yes" onClick={onConfirm} />
        </ModalFooter>
      </Modal>
    </Form>
  )
}

export default InventoryAddModal
